import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconEye } from '../../../../icon/IconEye';
import { Typography } from '../../../../typography/Typography';
import { BADGE_HEIGHT, ICON_SIZE } from './constants';
import { ViewsBadgeWrapper } from './styles';
import { ViewsBadgeProps } from './types';
import { formatViews } from './utils/formatViews';

export const ViewsBadge: FC<ViewsBadgeProps> = ({ views, ...other }) => {
    const t = useTranslation();

    if (!views) {
        return null;
    }

    const labelText = {
        thousand: t('тыс.'),
        millions: t('млн.'),
    };

    const formattedViews = formatViews(views, labelText);

    return (
        <ViewsBadgeWrapper {...other} height={BADGE_HEIGHT}>
            <IconEye size={ICON_SIZE} color="var(--always-white)" />
            <Typography
                variant="caption2"
                color="var(--always-white)"
                noWrap
                style={{ lineHeight: '0px' }}
            >
                {formattedViews}
            </Typography>
        </ViewsBadgeWrapper>
    );
};
